// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-business-permissions-EditRoleAccessList-SelectOfAccessedRoles-module__toolbarStack--boBQ5 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;
}
.src-business-permissions-EditRoleAccessList-SelectOfAccessedRoles-module__crud--LMqAW {
  display: flex;
  gap: 10px;
  align-items: center;
}
.src-business-permissions-EditRoleAccessList-SelectOfAccessedRoles-module__disabledCell--ybH5C {
  color: rgba(0, 0, 0, 0.3);
}
/*# sourceMappingURL=SelectOfAccessedRoles.module.css.map */`, "",{"version":3,"sources":["webpack://./SelectOfAccessedRoles.module.less","webpack://./src/business/permissions/EditRoleAccessList/SelectOfAccessedRoles.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;ACCF;ADEA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;ACAF;ADGA;EACE,yBAAA;ACDF;AACA,2DAA2D","sourcesContent":[".toolbarStack {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n}\n\n.crud {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.disabledCell {\n  color: rgba(0, 0, 0, 0.3);\n}\n",".toolbarStack {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n}\n.crud {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n.disabledCell {\n  color: rgba(0, 0, 0, 0.3);\n}\n/*# sourceMappingURL=SelectOfAccessedRoles.module.css.map */"],"sourceRoot":""}]);
// Exports
export var toolbarStack = `src-business-permissions-EditRoleAccessList-SelectOfAccessedRoles-module__toolbarStack--boBQ5`;
export var crud = `src-business-permissions-EditRoleAccessList-SelectOfAccessedRoles-module__crud--LMqAW`;
export var disabledCell = `src-business-permissions-EditRoleAccessList-SelectOfAccessedRoles-module__disabledCell--ybH5C`;
export default ___CSS_LOADER_EXPORT___;
